// Backend API URL - used across the app
// REACT_APP_BACKEND_URL is set at build time via .env.production
const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  "https://v4-copy-production.up.railway.app";

export const API = `${BACKEND_URL}/api`;
export default BACKEND_URL;
